import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { RichTextDisplay } from 'Packages/FacetDesign/Components';

export default buildFacetDesignOverride()
  .nameOverride('body', {
    _component: () => RichTextDisplay,
  }, overrideReadOnly);
